import { Capacitor } from "@capacitor/core";

// Real platform detection (never based on screen size).
// Returns true only when running inside a native app wrapper (Capacitor)
// or an installed PWA (standalone) on a mobile OS — never in a regular
// desktop/mobile browser tab.
export function isNativeApp() {
  try {
    if (Capacitor && typeof Capacitor.isNativePlatform === "function" && Capacitor.isNativePlatform()) {
      return true;
    }
  } catch (_) {}

  if (typeof window === "undefined") return false;

  // Installed PWA running in standalone mode on a mobile OS.
  const standalone =
    (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) ||
    window.navigator.standalone === true;
  const mobileOS = /android|iphone|ipad|ipod/i.test(window.navigator.userAgent || "");
  return Boolean(standalone && mobileOS);
}
